export default "__VITE_ASSET__BbDZbJ06__"